import loadable from '@loadable/component';
import Loader from '@/components/Button/Loader/Loader';

export const AsyncNewOfferIncreased = loadable(
  () => import('./NewOfferIncreased'),
);

export const AsyncNewOfferIncreasedCalculator = loadable(
  () => import('./NewOfferIncreasedCalculator'),
  {
    fallback: <Loader />,
  },
);
